import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  Input,
  InputNumber,
  Popconfirm,
  Form,
  notification,
  Typography,
  Space,
  Button,
  Drawer,
  Col,
  Row,
  Select,
  DatePicker,
  Switch,
  Dropdown,
  Menu,
} from "antd";
import {
  CalendarFilled,
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
  EyeOutlined,
  SettingOutlined,
  PlusOutlined,
  SearchOutlined,
  ManOutlined,
  MailOutlined,
  WomanOutlined,
} from "@ant-design/icons";
import { Link, useLocation, Redirect } from "react-router-dom";
import {
  BlankSpace,
  PageContainer,
  Xpagination,
  Xtable,
} from "../../../component/Xcomponent";
import moment from "moment";
import { connect } from "react-redux";
import PatientView from "../PatientView/PatientView";
import ConsultationView from "../ConsultationView/ConsultationView";
import _ from "lodash";
// action
import {
  getPatientList,
  getPatientListResetState,
} from "../../../action/getPatientListAction";
import {
  deletePatientList,
  deletePatientListReset,
} from "../../../action/deletePatientListAction";
import { DetailSpan, InputBox, PatientCard, XButton } from "./PatientListStyle";
import { PhoneIcon } from "../../../component/CustomIcons";
import "./PatientListStyle.css";
import HeaderContext from "../../../context/HeaderContext";
const originData = [];

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  
  const inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const PatientList = (props) => {
  const {
    getPatientList,
    getPatientListState,
    getPatientListResetState,
    fgetPatientListState,
    deletePatientList,
    deletePatientListReset,
    deletePatientListState,
  } = props;
  const [form] = Form.useForm();
  const [data, setData] = useState(originData);
  const [editingKey, setEditingKey] = useState("");

  // drawer
  const [visible, setVisible] = useState(false);
  const [view, setView] = useState({
    visible: false,
    id: null,
  });
  const [cview, setCView] = useState({
    visible: false,
    id: null,
  });
  const [redirect, setRedirect] = useState([false, ""]);
  const search = useLocation().search;
  console.log("search: ", search);

  const page = new URLSearchParams(search).get("page");
  console.log("pg", page);
  //pagination
  const [pagination, setPagination] = useState({
    page: page ? page : 1,
    records: 25,
  });

  const initialSearchData = {
    search_contain: "",
  };
  const [searchData, setSearchData] = useState(initialSearchData);

  const [Datalist, setDatalist] = useState([]);
  const [FinalDatalist, setFinalDatalist] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [searchText, setSearchText] = useState({});
  const {setTitle} = useContext(HeaderContext);
  setTitle("Patients");
  
  //callback
  useEffect(() => {
    return () => {
      getPatientListResetState();
    };
  }, []);

  // Callbacks
  useEffect(() => {
    getPatientList({
      page: pagination.page,
      records: pagination.records,
      ...searchData,
    });
  }, [refresh, pagination]);

  //pagination
  useEffect(() => {
    setRedirect([true, `/patient?page=${pagination.page}`]);
  }, [pagination]);

  // for deletePatintList
  useEffect(() => {
    if (deletePatientListState.apiState === "success") {
      deletePatientListReset();
      notification["success"]({
        message: deletePatientListState.message,
        placement: "topRight",
      });
      setRefresh(refresh + 1);
    }
    if (deletePatientListState.apiState === "error") {
      deletePatientListReset();
      notification["error"]({
        message: deletePatientListState.message,
        placement: "topRight",
      });
    }
  }, [deletePatientListState]);

  useEffect(() => {
    if (getPatientListState.apiState === "success") {
      setDatalist(getPatientListState.list);
      setFinalDatalist(getPatientListState.list);
      console.log("data", Datalist);
    }
  }, [getPatientListState]);
  // Functions

  //handle search input
  const handleOnChange = (e) => {
    //setList(data)
    // setSearchData({ ...searchData, [e.target.name]: e.target.value })
  };

  //clear filters
  const handleReset = () => {
    form.resetFields();
    setSearchData(initialSearchData);
    setPagination({ ...pagination, ["page"]: 1 });
  };

  //searchfilters
  const searchPatient = (value) => {
    let List = FinalDatalist;
    console.log("lists", List);
    let data = List.filter(
      (person) =>
        person.name.firstName
          .toLowerCase()
          .includes(value.search_contain.toLowerCase()) ||
        person.name.lastName
          .toLowerCase()
          .includes(value.search_contain.toLowerCase()) ||
        person.gender
          .toLowerCase()
          .includes(value.search_contain.toLowerCase()) ||
        person.email
          .toLowerCase()
          .includes(value.search_contain.toLowerCase()) ||
        person.phone.toLowerCase().includes(value.search_contain.toLowerCase())
    );
    setDatalist(data);

    console.log("SearchData", Datalist);
    // setPagination({ page: 1 })
  };

  const menu = (id) => (
    <div>
      <Space direction="vertical">
        <Button
          size="small"
          shape="circle"
          onClick={() => setView({ id: id, visible: true })}
          icon={<EyeOutlined />}
        ></Button>
        <Popconfirm
          title="Are you sure you want to delete this field?"
          onConfirm={() => deletePatientList({ id: id })}
          okText={`Delete`}
          cancelText="Cancel"
          okType="danger"
        >
          <Button
            size="small"
            shape="circle"
            icon={<DeleteOutlined />}
          ></Button>
        </Popconfirm>
      </Space>
    </div>
  );

  const DropdownMenu = (props) => (
    <Dropdown key="more" overlay={() => menu(props.item)}>
      <Button
        style={{
          border: "none",
          padding: 0,
        }}
      >
        <EllipsisOutlined rotate={90} />
      </Button>
    </Dropdown>
  );

  return (
    <>
      {redirect[0] && <Redirect to={redirect[1]} />}
      <PageContainer>
        <Form form={form} onFinish={searchPatient} layout="vertical">
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <Form.Item name="search_contain">
                <InputBox
                  type="text"
                  name="search_contain"
                  size="large"
                  onChange={handleOnChange}
                  placeholder="Search by patient’s name, phone number, email."
                  prefix={<SearchOutlined style={{ color: "#7e7b7b9c" }} />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={6} xl={4}>
              <Space>
                <Form.Item name="search_btn">
                  <XButton
                    className="search_btn"
                    size="large"
                    type="primary"
                    htmlType="submit"
                  >
                    Search
                  </XButton>
                </Form.Item>
                <Form.Item name="reset_btn">
                  <XButton
                    type="primary"
                    ghost
                    onClick={() => handleReset()}
                    size="large"
                    style={{ width: 100 }}
                  >
                    Reset
                  </XButton>
                </Form.Item>
              </Space>
            </Col>
          </Row>
        </Form>

        <Row gutter={[20, 20]}>
          {Datalist.map((item) => (
            <Col xs={24} sm={24} md={12} lg={12} xl={6}>
              <PatientCard
                title={`${item.name.firstName} ${item.name.lastName}`}
                extra={<DropdownMenu item={item._id} />}
              >
                {item.gender && (
                  <p>
                    {item.gender === "female" ? (
                      <WomanOutlined
                        style={{
                          padding: 6,
                          backgroundColor: "#F2F3F9",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <ManOutlined
                        style={{
                          padding: 6,
                          backgroundColor: "#F2F3F9",
                          borderRadius: "50%",
                        }}
                      />
                    )}

                    <DetailSpan>{item.gender}</DetailSpan>
                  </p>
                )}
                {item.phone && (
                  <p>
                    <span
                      role="img"
                      class="anticon anticon-man"
                      style={{
                        padding: 6,
                        backgroundColor: "#F2F3F9",
                        borderRadius: "50%",
                      }}
                    >
                      <PhoneIcon size="16" height="16" />
                    </span>
                    <DetailSpan>{item.phone}</DetailSpan>
                  </p>
                )}
                {item.email && (
                  <p className="mb-0">
                    <MailOutlined
                      style={{
                        padding: 6,
                        backgroundColor: "#F2F3F9",
                        borderRadius: "50%",
                        float: "left",
                      }}
                    />
                    <DetailSpan
                      style={{
                        fontSize: "small",
                      }}
                    >
                      <span className="emailEllipsis">{item.email}</span>
                    </DetailSpan>
                  </p>
                )}
                <p>
                  <DetailSpan style={{ padding: "6px", float: "right" }}>
                    <Link to={`/consultationview/${item._id}`}>
                      Consultation View
                    </Link>
                  </DetailSpan>
                </p>
              </PatientCard>
            </Col>
          ))}
        </Row>
        <BlankSpace />
        <Xpagination
          style={{gap:"5px",flexWrap:"wrap"}}
          pageSizeOptions={["25", "50", "100", "500"]}
          showSizeChanger
          total={getPatientListState.pagination?.total_records}
          onChange={(page, pageSize) =>
            setPagination({ page: page, records: pageSize })
          }
          current={pagination.page}
          defaultPageSize={pagination.records}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} items`
          }
        />
        <PatientView
          id={view.id}
          visible={view.visible}
          onClose={() => setView({ visible: false, id: null })}
        />
      </PageContainer>
    </>
  );
};

const mapStateToProps = (state) => ({
  getPatientListState: state.getPatientList,
  fgetPatientListState: state.getPatientList,
  deletePatientListState: state.deletePatientList,
});

const mapDispatchToProps = (dispatch) => ({
  getPatientList: (params) => dispatch(getPatientList(params)),
  getPatientListResetState: () => dispatch(getPatientListResetState()),
  deletePatientList: (params) => dispatch(deletePatientList(params)),
  deletePatientListReset: () => dispatch(deletePatientListReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientList);
